(ns app.domain.group.config.integration-model
  (:require [app.domain.workspace.model :as workspace-model]
            [cloudpermit-commons.schemas.general :as general]
            [schema.core :as s]))


(def integration-permit-statuses [:permit-integration.state/new
                                  :permit-integration.state/issued
                                  :permit-integration.state/finished
                                  :permit-integration.state/withdrawn
                                  :permit-integration.state/ready-to-issue
                                  :permit-integration.state/revoked
                                  :permit-integration.state/rejected
                                  :permit-integration.state/dormant
                                  :permit-integration.state/complete
                                  :permit-integration.state/approved
                                  :permit-integration.state/refused])


(s/defschema PermitStatus (apply s/enum integration-permit-statuses))


(def valid-permit-status! (s/validator PermitStatus))


(def domain-integration-state-map
  {:state.application/ready-to-issue        :permit-integration.state/ready-to-issue
   :state.application/permit-fee-payment    :permit-integration.state/ready-to-issue
   :state.application/license-fee-payment   :permit-integration.state/ready-to-issue
   :state.application/permit-issued         :permit-integration.state/issued
   :state.application/license-issued        :permit-integration.state/issued
   :state.application/finished              :permit-integration.state/finished
   :state.application/withdrawn             :permit-integration.state/withdrawn
   :state.application/rejected              :permit-integration.state/rejected
   :state.application/complete              :permit-integration.state/complete
   :state.application/approved              :permit-integration.state/approved
   :state.application/approved-in-principle :permit-integration.state/approved
   :state.application/refused               :permit-integration.state/refused
   ;; Back-end systems have no separate "denied" status, so a denial is reported as a refusal.
   :state.application/denied                :permit-integration.state/refused
   :execution.state/permit-issued           :permit-integration.state/issued
   :execution.state/construction-started    :permit-integration.state/issued
   :execution.state/finished                :permit-integration.state/finished
   :execution.state/dormancy                :permit-integration.state/dormant
   :execution.state/revoked                 :permit-integration.state/revoked})


(defn workspace->integration-state [workspace]
  (->> (workspace-model/workspace-target workspace)
       :domain/state
       (get domain-integration-state-map)))


(def mappable-workspace-attrs
  [:workspace/id
   :workspace/municipal-case-id
   :workspace/category-group-config
   :workspace/address
   :property/id
   :property/secondary-id
   :property/legal
   :property/zoning])


(s/defschema IntegrationWorkspaceAttrMapping {(apply s/enum mappable-workspace-attrs) general/NonBlankString})


(defn ws-attrs-for-ecm-by-type [permit-type]
  (case permit-type
    :permit-type/L [:workspace/id
                    :workspace/municipal-case-id
                    :workspace/category-group-config
                    :workspace/address]
    :permit-type/CR [:workspace/id
                     :workspace/municipal-case-id
                     :workspace/category-group-config]
    :permit-type/CE (butlast mappable-workspace-attrs)
    mappable-workspace-attrs))
